import { Icon, toast } from '@livable/saas-react-components';
import { Button, Typography } from '@mui/material';
import { observer } from 'mobx-react-lite';
import moment from 'moment';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { BigInfoAlert } from 'src/components/general/BigAlerts';
import FSEBillModal from 'src/components/resident/ResidentModal/MoveOutTab/FSEBillModal';
import { useStore } from 'src/stores';
import { dateToFormat } from 'src/utils/date';
import useStyles from '../styles';
const WarningBlock = observer(props => {
  var _store$fse$finalState;
  const classes = useStyles();
  const store = useStore();
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  const date = props.date,
    executeScroll = props.executeScroll,
    isFinalStatementEstimationEnabled = props.isFinalStatementEstimationEnabled,
    openTenantModal = props.openTenantModal,
    propertyId = props.propertyId,
    residencyId = props.residencyId,
    unitName = props.unitName,
    userProfileData = props.userProfileData;
  const finalStatementInfo = (_store$fse$finalState = store.fse.finalStatementInfo.filter(f => f.residencyId === residencyId)) === null || _store$fse$finalState === void 0 ? void 0 : _store$fse$finalState[0];
  const avaliableFrom = finalStatementInfo === null || finalStatementInfo === void 0 ? void 0 : finalStatementInfo.avaliableFrom;
  const hasStatement = finalStatementInfo === null || finalStatementInfo === void 0 ? void 0 : finalStatementInfo.statement;
  const postFseAutomatically = store.residencies.postFseAutomatically;
  const overdueDays = finalStatementInfo === null || finalStatementInfo === void 0 ? void 0 : finalStatementInfo.overdueDays;
  const status = finalStatementInfo === null || finalStatementInfo === void 0 ? void 0 : finalStatementInfo.status;
  const residentName = "".concat(userProfileData.firstName, " ").concat(userProfileData.lastName);
  const submitFinalStatements = async () => {
    const resp = await store.fse.submitFinalStatementsAsync.run({
      residencyId
    });
    return resp;
  };
  const handleSubmitFinalStatements = () => submitFinalStatements().then(() => {
    toast('success', {
      body: ['Final statement sent']
    });
  }).finally(() => store.residencies.toggleRefreshFlag(true));
  const FSEModal = type => /*#__PURE__*/React.createElement(FSEBillModal, {
    disabled: store.fse.submitFinalStatementsAsync.inProgress,
    isOpen: store.fse.FSEBillModalIsOpen,
    propertyId: propertyId,
    residentName: residentName,
    residencyId: residencyId,
    setFSEBillModalIsOpen: store.fse.setFSEBillModalIsOpen,
    submitFSE: handleSubmitFinalStatements,
    triggerType: type,
    unitName: unitName
  });
  const daysLeftToAvaliableFrom = moment(store.properties.serverBusinessDateOnly).diff(moment(avaliableFrom), 'days');
  const daysLeft = moment(store.properties.serverBusinessDateOnly).diff(moment(finalStatementInfo === null || finalStatementInfo === void 0 ? void 0 : finalStatementInfo.moveOutDate), 'days');
  let text = 'moving_out_note';
  let additionalText = () => {};
  if (status === 'SentToResident') {
    text = 'final_bill_posted'; //* Case 4
    additionalText = () => /*#__PURE__*/React.createElement("b", {
      className: classes.linkText,
      onClick: () => executeScroll()
    }, ' ', "here.");
  } else if (postFseAutomatically && daysLeftToAvaliableFrom < 0) {
    text = 'automatic_and_before';
  } else if (!postFseAutomatically && daysLeftToAvaliableFrom < 0) {
    text = 'manual_and_before';
    additionalText = () => /*#__PURE__*/React.createElement("b", {
      className: classes.linkText,
      onClick: () => openTenantModal('move-out')
    }, ' ', "please click here and update your settings.");
  } else if (postFseAutomatically && daysLeft <= 30) {
    text = 'automatic_and_after';
    additionalText = () => /*#__PURE__*/React.createElement("b", {
      className: classes.linkText,
      onClick: () => store.fse.setFSEBillModalIsOpen(true)
    }, ' ', "To review the Final Statement Estimation please click here.");
  } else if (!hasStatement && !postFseAutomatically && overdueDays > 0) {
    text = 'manual_move_out_date_passed'; //* Case 3
    additionalText = () => /*#__PURE__*/React.createElement("b", {
      className: classes.linkText,
      onClick: () => store.fse.setFSEBillModalIsOpen(true)
    }, ' ', "here.");
  } else if (!hasStatement && !postFseAutomatically && daysLeft <= 30) {
    text = store.company.companyFeatureStore.isAppfolio ? 'manual_and_after_appfolio' : 'manual_and_after';
    additionalText = () => store.company.companyFeatureStore.isAppfolio ? '' : /*#__PURE__*/React.createElement("b", {
      className: classes.linkText,
      onClick: () => store.fse.setFSEBillModalIsOpen(true)
    }, ' ', "here.");
  } else if (hasStatement) {
    text = 'final_bill_posted'; //* Case 4
    additionalText = () => /*#__PURE__*/React.createElement("b", {
      className: classes.linkText,
      onClick: () => executeScroll()
    }, ' ', "here.");
  }
  return /*#__PURE__*/React.createElement(BigInfoAlert, null, /*#__PURE__*/React.createElement(Typography, {
    variant: "h4"
  }, t('resident_account.moving_out_on'), " ", dateToFormat(date)), /*#__PURE__*/React.createElement(Typography, {
    variant: "body1"
  }, t("resident_account.".concat(isFinalStatementEstimationEnabled && hasStatement ? 'resident_move_out' : 'resident_move_out_with_fse'), {
    date: "".concat(dateToFormat(date)),
    interpolation: {
      escapeValue: false
    },
    residentName
  }), /*#__PURE__*/React.createElement("br", null), t("resident_account.".concat(text), {
    date: "".concat(dateToFormat(!postFseAutomatically && daysLeftToAvaliableFrom < 0 ? avaliableFrom : hasStatement ? hasStatement === null || hasStatement === void 0 ? void 0 : hasStatement.timestamp : date)),
    interpolation: {
      escapeValue: false
    },
    residentName
  }), additionalText()), hasStatement && status ? /*#__PURE__*/React.createElement(Button, {
    onClick: () => executeScroll(),
    variant: "actionButton",
    'custom-attribute': '819-resident-profile-page-warning-block'
  }, /*#__PURE__*/React.createElement("span", {
    className: "actionText"
  }, t('fse_page.view_final_statement'))) : null, hasStatement && !store.company.companyFeatureStore.isAppfolio ? /*#__PURE__*/React.createElement(Button, {
    onClick: () => openTenantModal('move-out'),
    variant: "actionButton",
    'custom-attribute': '820-resident-profile-page-warning-block'
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "edit"
  }), /*#__PURE__*/React.createElement("span", {
    className: "actionText"
  }, t('resident_account.edit_or_cancel'))) : null, isFinalStatementEstimationEnabled && (status === 'Overdue' || status === 'ReadyForReview') ? /*#__PURE__*/React.createElement("span", {
    className: classes.fseButton
  }, FSEModal('actionButton')) : null);
});
export default WarningBlock;